module.exports = __webpack_public_path__ + "static/illu-my-property-387e66f71622ea73f7207de9061170f1.png";